/**
 * Picklist sizing options for the Dropdown component. See /internal/demos/components/dropdown for visual examples.
 * EXPAND_TO_WIDEST_ITEM: Picklist starts at width of the dropdown placeholder, but grows to fit the widest item.
 * SAME_AS_DROPDOWN: Picklist takes width of the dropdown placeholder.
 *
 * TODO EN-77646: convert this to an enum
 */
export const picklistSizingStrategy: Record<string, 'EXPAND_TO_WIDEST_ITEM' | 'SAME_AS_DROPDOWN'> = {
  EXPAND_TO_WIDEST_ITEM: 'EXPAND_TO_WIDEST_ITEM',
  SAME_AS_DROPDOWN: 'SAME_AS_DROPDOWN',
};
